import React from 'react'

const Popular_Destination_Area_Start = () => {
  return (
    <div>
      
      <section class="popular-destinations-area rel z-1">
            <div class="container-fluid">
                <div class="popular-destinations-wrap br-20 bgc-lighter pt-100 pb-70">
                    <div class="row justify-content-center">
                        <div class="col-lg-12">
                            <div class="section-title text-center counter-text-wrap mb-70" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                                <h2>Explore Popular Destinations</h2>
                                <p>One site <span class="count-text plus" data-speed="3000" data-stop="34500">0</span> most popular experience</p>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-3 col-md-6">
                                <div class="destination-item style-two" data-aos="flip-up" data-aos-duration="1500" data-aos-offset="50">
                                    <div class="image">
                                        <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                        <img src="https://images.pexels.com/photos/3222192/pexels-photo-3222192.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                                    </div>
                                    <div class="content">
                                        <h6><a href="/Destination">Thailand beach</a></h6>
                                        <span class="time">5352+ tours & 856+ Activity</span>
                                        <a href="#" class="more"><i class="fas fa-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6">
                                <div class="destination-item style-two" data-aos="flip-up" data-aos-delay="100" data-aos-duration="1500" data-aos-offset="50">
                                    <div class="image">
                                        <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                        <img src="https://images.pexels.com/photos/3222197/pexels-photo-3222197.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                                    </div>
                                    <div class="content">
                                        <h6><a href="/Destination">Parga, Greece</a></h6>
                                        <span class="time">5352+ tours & 856+ Activity</span>
                                        <a href="#" class="more"><i class="fas fa-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="destination-item style-two" data-aos="flip-up" data-aos-delay="200" data-aos-duration="1500" data-aos-offset="50">
                                    <div class="image">
                                        <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                        <img src="https://images.pexels.com/photos/1004584/pexels-photo-1004584.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                                    </div>
                                    <div class="content">
                                        <h6><a href="/Destination">Castellammare del Golfo, Italy</a></h6>
                                        <span class="time">5352+ tours & 856+ Activity</span>
                                        <a href="#" class="more"><i class="fas fa-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="destination-item style-two" data-aos="flip-up" data-aos-duration="1500" data-aos-offset="50">
                                    <div class="image">
                                        <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                        <img src="https://images.pexels.com/photos/1285625/pexels-photo-1285625.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
                                    </div>
                                    <div class="content">
                                        <h6><a href="/Destination">Reserve of Canada, Canada</a></h6>
                                        <span class="time">5352+ tours & 856+ Activity</span>
                                        <a href="#" class="more"><i class="fas fa-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6">
                                <div class="destination-item style-two" data-aos="flip-up" data-aos-delay="100" data-aos-duration="1500" data-aos-offset="50">
                                    <div class="image">
                                        <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                        <img src="https://images.pexels.com/photos/17298484/pexels-photo-17298484/free-photo-of-bridge-over-ravine.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                                    </div>
                                    <div class="content">
                                        <h6><a href="/Destination">Dubai united states</a></h6>
                                        <span class="time">5352+ tours & 856+ Activity</span>
                                        <a href="#" class="more"><i class="fas fa-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6">
                                <div class="destination-item style-two" data-aos="flip-up" data-aos-delay="200" data-aos-duration="1500" data-aos-offset="50">
                                    <div class="image">
                                        <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                                        <img src="https://images.pexels.com/photos/19278092/pexels-photo-19278092/free-photo-of-scenic-mountain-landscape.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Destination"/>
                                    </div>
                                    <div class="content">
                                        <h6><a href="/Destination">Milos, Greece</a></h6>
                                        <span class="time">5352+ tours & 856+ Activity</span>
                                        <a href="#" class="more"><i class="fas fa-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Popular_Destination_Area_Start
